module.exports = __webpack_public_path__ + "static/media/back-track.03b95bda.svg";